import Button from '../ui/Button.jsx';
import { Card, CardBody, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Text = ({ ...props }) => {
    const { icon, heading, website, subheading, text, button, fn } = props;

    return (
        <div className="component-website">
            <HeadingOne icon={icon} heading={heading} />

            <Card>
                <CardHeader>
                    <h3 className="url">{website}</h3>
                </CardHeader>
                <CardBody>
                    <h2>{subheading}</h2>

                    <div dangerouslySetInnerHTML={{ __html: text }}></div>
                    {button && (
                        <div className="mt-12 text-center">
                            <Button {...button} onClick={() => fn.handleAction(button.action)} />
                        </div>
                    )}
                </CardBody>
            </Card>
        </div>
    );
};

export default Text;
